<template>
  <div>
    <div :id="id" class="barchart-style" ref="barchart"></div>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'rgba(88,198,228, 1)'
    },
    id: {
      type: String,
      default: '',
      require: true
    }
  },
  data() {
    return {
      barchart: {}
    }
  },
  mounted() {
    // this.chartInit()
    // window.addEventListener('resize', () => {
    //   this.barchart.dispose()
    //   setTimeout(() => {
    //     this.chartInit()
    //   }, 20)
    // })
  },
  methods: {
    chartInit(data) {
      const colors = ['#f3b000', 'rgba(127,127,127, 1)', '#91CC75', '#EE6666'];
      this.barchart = this.$echarts.init(document.getElementById(this.id))
      const serieList = data.serieList
      const chartLegend = []
      const chartSeries = []
      for (let index = 0; index < serieList.length; index++) {
        const serieData = serieList[index]
        chartLegend.push(serieData.name)
        const chartSerie = {
          name: serieData.name,
          type: serieData.type,
          barWidth: '20%',
          barMaxWidth: '30',
          data: serieData.data,
          itemStyle: {
            color: colors[index],
            barBorderRadius: [5, 5, 0, 0]
          }
        }
        chartSeries.push(chartSerie)
      }

      this.barchart.setOption({
        title: {
          left: 'center',
          text: data.name
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          data: data.xData,
          // axisLine: {
          //   show: false
          // },
          // axisTick: {
          //   show: false
          // },
          // axisLabel: {
          //   interval: 0,
          //   // rotate: 20,
          //   // width: 90, // 将内容的宽度固定
          //   overflow: 'truncate', // 超出的部分截断
          //   truncate: '...' // 截断的部分用...代替
          // }
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              type: 'dashed'
            }
          }
        },
        // dataZoom: {
        //   show: true,
        //   start: 0,
        //   type: 'inside',
        //   end: (5 / data.xData.length) * 100,
        //   zoomLock: true
        // },
        series: chartSeries,
        grid: {
          left: '5%',
          top: '20%',
          right: '0%',
          bottom: '20%'
        },
        legend: {
          orient: 'vertical',
          left: 'center',
          bottom: 'bottom',
          data: chartLegend
        }
      })
    }
  }
}
</script>
<style>
.barchart-style {
    width:100%;
    height:236px;
}
</style>
